import {API, API_PAYMENT, Setup} from '../../Services';
import {AxiosCache} from "../../Services/AxiosCache/AxiosCache";

async function HomeData(){
    const token = localStorage.getItem('token')
    let mallId= localStorage.getItem('mallId');
    // return API.get(`/malls/${mallId?mallId:Setup.default_malls}/home`,{
    //     headers: { 'Authorization':  `Bearer ${token}`}
    // });

    let url =`/malls/${mallId}/home-public`
    let config = {}

    return await AxiosCache({url,config,time: 1})

    // return API.get(`/malls/${mallId?mallId:Setup.default_malls}/home-public`);
}

async function AssignCoupon(id){
    const token = localStorage.getItem('token')
    return API.post(`/coupons/${id}/assign`,{},{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function getFake_api(){
    return API_PAYMENT.get(`/todos/1`,{});
}


async function MenuData(merchatId){
    const token = localStorage.getItem('token')
    return API.get(`/shop/${merchatId}/product_category/?parent__isnull=true`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function MenuCats(merchatId,parentId){
    const token = localStorage.getItem('token')
    return API.get(`/shop/${merchatId}/product_category_public/?parent__uid=${parentId}`);
}


async function MallLandData(mallId,merchantId,pageId){
    return API.get(`/page/${mallId}/${merchantId}/${pageId}`);
}

export {HomeData,MenuData,MenuCats,AssignCoupon,MallLandData,getFake_api};
